import { basicSwrOptions } from '@ori/checkout-utils';
import { SWRConfig } from '@ori/fetching';
import { ApiClientProvider as StaticApiClientProvider } from '@ori/static-api-client-react';
import type { FC, PropsWithChildren } from 'react';

// TO-DO: Maybe move these into @ori/checkout-utils?
const timeout = 10000;
const swrConfig = {
  focusThrottleInterval: 300000,
  suspense: false,
  ...basicSwrOptions,
};

interface ApiProviderProps {
  currentLanguage: string;
  staticApiUrl: string;
  tenant: string;
}

export const ApiProvider: FC<PropsWithChildren<ApiProviderProps>> = ({
  children,
  currentLanguage: language,
  staticApiUrl,
  tenant,
}) => {
  const staticClientProps = { baseUrl: staticApiUrl, language, tenant, timeout };

  return (
    <SWRConfig value={swrConfig}>
      <StaticApiClientProvider {...staticClientProps}>{children}</StaticApiClientProvider>
    </SWRConfig>
  );
};
